import React, { useState } from 'react';

function SurveyStepFifteen({ formData, onNext }) {
    const [supportFeeling, setSupportFeeling] = useState(formData.supportFeeling || '');
    const [supportComments, setSupportComments] = useState(formData.supportComments || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!supportFeeling) {
            setError('Please select a rating.');
            return;
        }
        setError('');
        onNext({ supportFeeling, supportComments });
    };

    const ratingOptions = ['N/A', ...Array.from({ length: 10 }, (_, i) => (i + 1).toString())];

    return (
        <div className="step-form">
            <h6 className="mb-4">Section 4: Workplace & Culture</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <label className="form-label">
                How supported do you feel by your manager and colleagues? <span className="text-danger">*</span>
            </label>

            <div className="d-flex flex-wrap gap-2 mb-4 justify-content-around">
                {ratingOptions.map((option) => (
                    <div key={option} className="form-check rating_btn">
                        <input
                            type="radio"
                            id={`support-feeling-${option}`}
                            name="supportFeeling"
                            value={option}
                            checked={supportFeeling === option}
                            onChange={() => setSupportFeeling(option)}
                        />
                        <label htmlFor={`support-feeling-${option}`}>{option}</label>
                    </div>
                ))}
            </div>

            <div className="mb-3">
                <label className="form-label">Additional comments (optional):</label>
                <textarea
                    className="form-control"
                    rows="4"
                    value={supportComments}
                    onChange={(e) => setSupportComments(e.target.value)}
                    placeholder="Share any additional thoughts here..."
                />
            </div>

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!supportFeeling}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default SurveyStepFifteen;
